import React from 'react';
import PropTypes from 'prop-types';

import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  FormControl,
  InputLabel,
  OutlinedInput,
  Dialog,
  DialogTitle,
  DialogContent,
  Stack
} from '@mui/material';

import { CloseOutlined, AttachFileOutlined } from '@mui/icons-material';
import {
  dialogHeaderStyles,
  multitextFieldSx,attachButtonSx
} from '../../../../../Common/components/Styles/InputStyles';
import CommonDialogActions from '../../../../../Common/components/CommonDialogActions';

const MessageModal = ({ open, onClose, onSend }) => {
  const handleClose = () => {
    onClose();
  };
  return (
    <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}> Message</Typography>

          <Typography sx={dialogHeaderStyles.subtitle}>
           Send a secure message to the patient.
          </Typography>
        </Box>

        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{ color: '#424242' }}>
          <CloseOutlined />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 2 }}>
        <Stack spacing={1.4} sx={{ mt: 2 }}>
          <FormControl
            fullWidth
            variant="outlined"
            sx={{ ...multitextFieldSx }}>
            <InputLabel>Patient Message</InputLabel>

            <OutlinedInput
              id="patient-message"
              multiline
              rows={4}
              label="Patient Message"
            />
          </FormControl>

          <Button
            variant="outlined"
            startIcon={<AttachFileOutlined />}
            sx={attachButtonSx}>
            Attach Doctor&apos;s Order
          </Button>
        </Stack>
      </DialogContent>

      <CommonDialogActions
        onCancel={handleClose}
        onSubmit={handleClose}
        submitText="Save"
        disabled={''}
      />
    </Dialog>
  );
};

MessageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSend: PropTypes.func
};

export default MessageModal;
